
import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Router from 'root/router';
import Modals from 'root/modals';
import View from 'view/base';
import View_Menu from 'page/account/menu';
import View_Referral_Invoice_Row from 'view/invoice/referral_invoice_row';
import Chart_Referral from 'chart/referral';

export default View.extend({
    tagName: 'section',

    page: 1,
    limit: 10,

    range: 30,

    views: {
        menu: {},
        referral_invoices: {},
    },

    events: {
        'click .days li'           : 'rangeChange',
        'click .withdraw-cash'     : 'withdrawCash',
        'click .previous'          : 'prevPage',
        'click .next'              : 'nextPage',
        'click .get-referral-link' : 'getReferralLink'
    },

    dom_handlers: {
        rangeChange: function(e) {
            var selected_item = $(e.currentTarget);

            this.$el.find('ul.days li').removeClass('active');
            this.$el.find('ul.days').parents('.button-dropdown').find('> button > span').text(selected_item.text());
            selected_item.addClass('active');

            this.range = parseInt(this.$el.find('ul.days li.active').data('value'), 10);

            Cache.add('referral_summary_range', this.range, true);

            this.onPageReady.call(this);
        },

        withdrawCash: function(e) {
            Modals.withdrawReferralFee();
        },

        prevPage: function(e) {
            if (Cache.referral_invoice.length === 0) {
                return;
            }

            this.page--;
            this.page = Math.max(this.page, 1);
            this.goToPage();
        },

        nextPage: function(e) {
            if (Cache.referral_invoice.length === 0) {
                return;
            }

            var total_page = Math.ceil(Cache.referral_invoice.length / this.limit);

            this.page++;
            this.page = Math.min(this.page, total_page);
            this.goToPage();
        },

        getReferralLink: function(e) {
            Modals.referAccount();
        }
    },

    goToPage: function() {
        var total_page = Math.ceil(Cache.referral_invoice.length / this.limit);
        this.$el.find('.current-page b').text(this.page + ' of ' + total_page);

        var start = (this.page - 1) * this.limit;
        var stop  = start + this.limit - 1;

        _.each(this.views.referral_invoices, function(view) {
            view.remove();
        });

        Cache.referral_invoice.each(function(model, index) {
            if (index >= start && index <= stop) {
                this.views.referral_invoices['_' + model.id] = new View_Referral_Invoice_Row({model: model});
                this.views.referral_invoices['_' + model.id].render().$el.insertAfter(this.$el.find('table tr:last'));
            }
        }, this);
    },

    onPageReady: function() {
        var query_string = Router.getQueryString();
        if (query_string.referral_code) {
            Modals.referAccount();
        }

        Cache.app.request({
            action: 'account/referralData',
            data: {days: this.range},
            context: this,
            success: function(response) {
                this.$el.find('.data-loader').hide();

                Chart_Referral.render(this.$el.find('#chart_referral'), response.chart_data);

                Cache.referral_invoice.reset(response.transactions);
            }
        });
    },

    initialize: function() {
        if (Cache.get('referral_summary_range')) {
            var range = parseInt(Cache.get('referral_summary_range'), 10);

            if ([30, 60, 90, 120, 360].indexOf(range) !== -1) {
                this.range = range;
            }
        }

        this.views.menu = new View_Menu();

        this.listenTo(Cache.account,          'change:referral_balance', this.updateReferralBalance);
        this.listenTo(Cache.referral_invoice, 'reset',                   this.renderTransactions);
    },

    updateReferralBalance: function() {
        this.$el.find('.credit-balance').text((Cache.account.get('referral_balance') / 100).toFixed(2));
    },

    renderTransactions: function() {
        if (Cache.referral_invoice.length) {
            this.goToPage();
        } else {
            this.$el.find('.no-payouts').remove();
            $('<div>').addClass('no-payouts').html('<div class="divider-large"></div><p class="text-align-center">No payouts found in your account</p>').insertAfter(this.$el.find('table:first'));
        }
    },

    render: function() {
        UI.setPageTitle('Referral Program');

        var content = '';

        content += '<main class="xlarge">';

        content += '<h3 class="widget-title"><b>Referral Credit</b></h3>' +
                    '<div class="box">' +
                        '<div class="overflow-hidden">' +
                            '<div class="referral-welcome">' +
                                '<button class="get-referral-link primary medium">Get my referral link</button>' +
                                '<h3>👏 Thanks for referring your friends to Userback. You\'re awesome!</h3>' +
                                '<p class="info">To learn more about the Referral Program, please refer to this <a href="https://support.userback.io/en/articles/5209194" target="_blank">help article</a>.</p>' +
                            '</div>' +
                            '<div class="divider-24"></div>' +
                            '<div class="grid-4-4-4 grid-none-mobile">' +
                                '<div class="referral-credit-box referral-credit-box-success">' +
                                    '<div class="icon-box"><i class="fad fa-chart-line fa-2x"></i></div>' +
                                    '<span class="money money-large"><span class="symbol"><i class="fad fa-dollar-sign"></i></span><span class="number">' + (Cache.account.get('referral_credit_total') / 100).toFixed(2) + '</span></span>' +
                                    '<div class="info">Total Earned</div>' +
                                '</div>' +
                                '<div class="referral-credit-box referral-credit-box-secondary">' +
                                    '<div class="icon-box"><i class="fad fa-file-invoice-dollar fa-2x"></i></div>' +
                                    '<span class="money money-large"><span class="symbol"><i class="fad fa-dollar-sign"></i></span><span class="number">' + (Cache.account.get('referral_credit_used') / 100).toFixed(2) + '</span></span>' +
                                    '<div class="info">Used as Account Credit</div>' +
                                '</div>' +

                                '<div class="referral-credit-box referral-credit-box-primary">' +
                                    '<div class="icon-box"><i class="fad fa-badge-dollar fa-2x"></i></div>' +
                                    '<span class="money money-large"><span class="symbol"><i class="fad fa-dollar-sign"></i></span><span class="number credit-balance">' + (Cache.account.get('referral_balance') / 100).toFixed(2) + '</span></span>' +
                                    '<div class="info">Your Balance</div>' +
                                    '<div class="text-align-center">' +
                                        '<button class="primary primary-invert small withdraw-cash margin-top-24">Payout</button>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>';

        content += '<div class="divider-12"></div>';

        content += '<div class="float-right margin-top-10">' +
                        '<div class="button-dropdown">' +
                            '<button class="text-invert square small inline"><span>Last ' + this.range + ' Days</span> <i class="far fa-angle-down"></i></button>' +
                            '<div>' +
                                '<ul class="dropdown days">' +
                                    '<li data-value="30"'  + (this.range === 30  ? ' class="active"' : '') + '>Last 30 Days</li>' +
                                    '<li data-value="60"'  + (this.range === 60  ? ' class="active"' : '') + '>Last 60 Days</li>' +
                                    '<li data-value="90"'  + (this.range === 90  ? ' class="active"' : '') + '>Last 90 Days</li>' +
                                    '<li data-value="120"' + (this.range === 120 ? ' class="active"' : '') + '>Last 120 Days</li>' +
                                    '<li data-value="360"' + (this.range === 360 ? ' class="active"' : '') + '>Last 360 Days</li>' +
                                '</ul>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<h3 class="widget-title"><b>Your Referred Accounts</b></h3>' +
                    '<div class="box">' +
                        '<div class="data-loader loader loader-white loader-small" style="height:200px;"></div>' +
                        '<div id="chart_referral"></div>' +
                    '</div>';

        content += '<div class="divider-12"></div>';

        content += '<h3 class="widget-title"><b>Payout History</b></h3>' +
                    '<div class="box">' +
                        '<div class="overflow-auto">' +
                            '<table cellpadding="0" cellspacing="0">' +
                                '<tr>' +
                                    '<th>Transaction ID</th>' +
                                    '<th>Total Amount</th>' +
                                    '<th>Description</th>' +
                                    '<th>Paid to</th>' +
                                    '<th>Status</th>' +
                                '</tr>' +
                            '</table>' +
                            '<div class="data-loader loader loader-white loader-small" style="height:200px;"></div>' +
                        '</div>' +
                        '<div class="text-align-center">' +
                            '<div class="button-group margin-top-20" data-autohighlight="false">' +
                                '<button class="text small inline previous tooltip" data-title="Previous"><i class="far fa-angle-left"></i></button>' +
                                '<button class="small inline current-page"><b>1 of 1</b></button>' +
                                '<button class="text small inline next tooltip" data-title="Next"><i class="far fa-angle-right"></i></button>' +
                            '</div>' +
                        '</div>' +
                    '</div>';

        content += '</main>';

        this.$el.html(content);

        this.views.menu.render().$el.prependTo(this.$el.find('main'));

        return this;
    }
});